import { gql } from 'apollo-boost';

export const deleteEmailTemplate = gql`
mutation deleteEmailTemplate(
    $id: Int!,
) {
  deleteEmailTemplate(
    id: $id,
) {
    success
  }
}
`;
